import styled, { keyframes } from "styled-components";
const blink = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;
export const LoadingContainer = styled.div`
  padding: 100px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  .text {
    font-size: 32px;
    animation: ${blink} 2s ease-in infinite;
  }
`;
